var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('create-pr-detail',{model:{value:(_vm.details),callback:function ($$v) {_vm.details=$$v},expression:"details"}})],1),_c('v-col',{attrs:{"cols":"9"}},[_c('table-pr-detail',{attrs:{"items":_vm.details}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }